module.exports = __webpack_public_path__ + "img/906831399d4118ca3a9b82a67336763e.61011368.png";